import { axios } from "../axiosInstance";

export interface ManageSecondmentActor {
  contactId: string;
  companyId: string;
  isFirmAdmin: boolean;
  firstName: string;
  lastName: string;
}

export interface ManageSecondmentRow {
  secId: number;
  firmId: number;
  title: string;
  deadline: string;
  deadlineSort: number;
  submittedDate: string;
  submittedSort: number;
  active: string;
}

export interface ManageSecondmentOption {
  id: number;
  name: string;
}

export interface ManageSecondmentDraft {
  secId: number;
  contactId: number;
  openDeadline: boolean;
  deadline: string;
  openPosting: boolean;
  dateFrom: string;
  dateTo: string;
  title: string;
  duration: number;
  locationIds: number[];
  allLocations: boolean;
  description: string;
  practiceIds: number[];
  allPractices: boolean;
  noRequirements: boolean;
  requirements: string;
  additionalInfo: string;
  overview: string;
}

export interface ManageSecondmentEditor {
  contacts: ManageSecondmentOption[];
  locations: ManageSecondmentOption[];
  practices: ManageSecondmentOption[];
  draft: ManageSecondmentDraft | null;
  overview: string;
}

export interface ManageSecondmentSavePayload {
  mode: "add" | "update";
  secId: number | null;
  secContactId: number;
  openDeadline: boolean;
  deadline: string;
  openPosting: boolean;
  dateFrom: string;
  dateTo: string;
  title: string;
  duration: number;
  locationIds: number[];
  allLocations: boolean;
  description: string;
  practiceIds: number[];
  allPractices: boolean;
  noRequirements: boolean;
  requirements: string;
  additionalInfo: string;
  overview: string;
}

export interface ManageSecondmentSaveResult {
  saved: boolean;
  errors: string[];
  message: string;
  secId: number | null;
}

function queryString(params: Record<string, string>): string {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value) {
      search.set(key, value);
    }
  });
  const text = search.toString();
  return text ? `?${text}` : "";
}

function actorQuery(actor: ManageSecondmentActor): Record<string, string> {
  return {
    contactId: actor.contactId,
    companyId: actor.companyId,
    firmAdmin: actor.isFirmAdmin ? "1" : "0",
    firstName: actor.firstName,
    lastName: actor.lastName,
  };
}

export async function getManageSecondmentList(actor: ManageSecondmentActor): Promise<ManageSecondmentRow[]> {
  const response = await axios.Get(`./manageSecondments${queryString({ view: "list", ...actorQuery(actor) })}`);
  return (response.data as { rows: ManageSecondmentRow[] }).rows;
}

export async function getManageSecondmentEditor(actor: ManageSecondmentActor, secId: string): Promise<ManageSecondmentEditor> {
  const response = await axios.Get(`./manageSecondments${queryString({ view: "editor", ...actorQuery(actor), secId })}`);
  return response.data as ManageSecondmentEditor;
}

export async function saveManageSecondment(actor: ManageSecondmentActor, payload: ManageSecondmentSavePayload): Promise<ManageSecondmentSaveResult> {
  const response = await axios.Post("./manageSecondments", { action: "save", ...actor, ...payload });
  return response.data as ManageSecondmentSaveResult;
}

export async function deleteManageSecondment(actor: ManageSecondmentActor, secId: number): Promise<void> {
  await axios.Post("./manageSecondments", { action: "delete", ...actor, secId });
}
